import {useContext} from 'react'
import "./Loader.css"
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { Store } from "../../store";


const Loader = () => {
  const { state: { globalLoader } } = useContext(Store);
  const {isActive, loaderText} = globalLoader;

  return (
    <div className="loader-container">
      <div className="loaderIcon">
       <div className='sceneLoaderText'>{loaderText}<div className='sceneLoader'></div></div>
      </div>
    </div>
  );
}

export default Loader